module.exports = __webpack_public_path__ + "img/persona-generator.2cb336b8.svg";